import React, {useRef} from "react";
import Page from "../../../../components/page/Page";
import PageContent from "../../../../components/page/PageContent";
import PageHeader from "../../../../components/page/PageHeader";
import PageTitle from "../../../../components/page/PageTitle";
import {t} from "../../../../store/localization/TranslMessasge";
import CollectionsGrid from "./collectionsgrid/CollectionsGrid";
import {CollectionsTranslationKey} from "./CollectionsTranslationKey";
import constructCollectionsController, {CollectionsController} from "./controller/CollectionsController";
import collectionsService from "./service/CollectionsService";


export default function CollectionsPage() {
    const collectionsController = useRef<CollectionsController>(constructCollectionsController(collectionsService));

    return (
        <Page>
            <PageHeader>
                <PageTitle title={t(CollectionsTranslationKey.TITLE)} />
            </PageHeader>
            <PageContent>
                <CollectionsGrid controller={collectionsController.current} />
            </PageContent>
        </Page>
    )
}